import { getParam, getExpiryRecord, getFormattedDate, getFormattedTime, getCookie, setCookie } from "./wp-wpp-utils.js";

export function storeGclid() {
    let gclidParam = getParam('gclid');
    let gclsrcParam = getParam('gclsrc');
    let isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

    if (gclidParam && isGclsrcValid) {
        let gclidRecord = getExpiryRecord(gclidParam);
        setCookie('gclid', JSON.stringify(gclidRecord), 90);
    }
}

export function storeGbraid() {
    let gbraid = getParam('gbraid');

    if (!gbraid) {
        return;
    }

    gbraid = getExpiryRecord(gbraid);
    setCookie('gbraid', JSON.stringify(gbraid), 90);
}

export function storeFbclid() {
    let fbclid = getParam('fbclid');

    if (!fbclid) {
        return;
    }

    fbclid = getExpiryRecord(fbclid);
    setCookie('fbclid', JSON.stringify(fbclid), 90);
}

export function storeKeyword() {
    let keyword = getParam('utm_term');

    if (!keyword) {
        return;
    }

    keyword = getExpiryRecord(keyword);
    setCookie('keyword', JSON.stringify(keyword), 90);
}

export function storeReferer() {
    let refererPage = document.referrer;

    if (getCookie('referer_page')) {
        return;
    }

    if (!refererPage || refererPage === "") {
        return;
    }

    setCookie('referer_page', refererPage, 90);
}

export function fillFormFields() {
    let gclid = getCookie('gclid');
    let gbraid = getCookie('gbraid');
    let fbclid = getCookie('fbclid');
    let keyword = getCookie('keyword');
    let refererPage = getCookie('referer_page');

    gclid = gclid ? JSON.parse(gclid) : null;
    gbraid = gbraid ? JSON.parse(gbraid) : null;
    fbclid = fbclid ? JSON.parse(fbclid) : null;
    keyword = keyword ? JSON.parse(keyword) : null;

    let fields = {
        'gclid_field': getValueFor(gclid),
        'gbraid_field': getValueFor(gbraid),
        'fbclid_field': getValueFor(fbclid),
        'keyword_field': getValueFor(keyword),
        'referer_page': refererPage ? refererPage : '',
        'date': getFormattedDate(),
        'time': getFormattedTime(),
        'url': window.location.href,
    };

    setFormFields(fields);
}

function getValueFor(data) {
    return isValid(data) ? data.value : '';
}

function isValid(data) {
    return data && new Date().getTime() < data.expiryDate;
}

function setFormFields(fields) {
    for (const [name, value] of Object.entries(fields)) {
        let field = document.querySelector('[name="' + name + '"]');

        if (!field) {
            continue;
        }

        field.value = value;
    }
}

window.addEventListener('load', () => {
    storeGclid();
    storeGbraid();
    storeFbclid();
    storeReferer();
    storeKeyword();

    fillFormFields();
});
